/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ id: NonNullable<unknown> }} Chat_Error_ReferenceInputs */



/**
* | output |
* | --- |
* | "Error reference: {id}" |
*
* @param {Chat_Error_ReferenceInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_error_reference = /** @type {((inputs: Chat_Error_ReferenceInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Error_ReferenceInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Fehler-Referenz: ${i?.id}`)
	return /** @type {LocalizedString} */ (`Error reference: ${i?.id}`)
});